import * as React from "react";
function SvgInstagramUntinted(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M30.9 9.8a10.33 10.33 0 00-.7-3.6 8.75 8.75 0 00-1.7-2.7 7.63 7.63 0 00-2.7-1.7 11.07 11.07 0 00-3.6-.7C20.6 1 20.1 1 16 1s-4.6 0-6.2.1a10.33 10.33 0 00-3.6.7 8.75 8.75 0 00-2.7 1.7 7.63 7.63 0 00-1.7 2.7 11.07 11.07 0 00-.7 3.6C1 11.4 1 11.9 1 16s0 4.6.1 6.2a10.33 10.33 0 00.7 3.6 8.75 8.75 0 001.7 2.7 7.63 7.63 0 002.7 1.7 11.07 11.07 0 003.6.7c1.6.1 2.1.1 6.2.1s4.6 0 6.2-.1a10.33 10.33 0 003.6-.7 8.75 8.75 0 002.7-1.7 7.63 7.63 0 001.7-2.7 11.07 11.07 0 00.7-3.6c.1-1.6.1-2.1.1-6.2s0-4.6-.1-6.2zm-2.7 12.3a9.22 9.22 0 01-.5 2.8 4.83 4.83 0 01-2.8 2.8 9.22 9.22 0 01-2.8.5c-1.6.1-2.1.1-6.1.1s-4.5 0-6.1-.1a9.22 9.22 0 01-2.8-.5 4.83 4.83 0 01-2.8-2.8 9.22 9.22 0 01-.5-2.8c-.1-1.6-.1-2.1-.1-6.1s0-4.5.1-6.1a9.22 9.22 0 01.5-2.8 4.83 4.83 0 012.8-2.8 9.22 9.22 0 012.8-.5c1.6-.1 2.1-.1 6.1-.1s4.5 0 6.1.1a9.22 9.22 0 012.8.5 4.83 4.83 0 012.8 2.8 9.22 9.22 0 01.5 2.8c.1 1.6.1 2.1.1 6.1s0 4.5-.1 6.1zM16 8.3a7.64 7.64 0 10.12 0zM16 21a5 5 0 115-5 5 5 0 01-5 5zm8-14.8A1.8 1.8 0 1122.2 8 1.79 1.79 0 0124 6.2z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgInstagramUntinted);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
